import React, { useEffect } from 'react';

import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Center,
  Flex,
  HStack,
  Stack,
} from '@chakra-ui/react';
import { map } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';
import { PermissionComponent } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardAws/Help/PermissionComponent';
import { permissionStyles } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardAws/styles';
import { selectCloudAccountWizard } from 'containers/Setup/CloudAccounts/CloudAccountWizard/selectors';
import { collapseExpandIcon } from 'containers/Visibility/Components/InventoryRowDetails/utils';

import { actions } from '../../../slice';

export const Permissions = () => {
  const dispatch = useDispatch();
  const { templatePermissions } = useSelector(selectCloudAccountWizard);
  const { data, isLoading } = templatePermissions;

  useEffect(() => {
    dispatch(actions.loadTemplatePermissions({}));
  }, [dispatch]);

  const permissionItem = permission => {
    const permissionsMapping = {
      'SecurityAuditPolicy (AWS Managed Policy)': {
        label: 'Security Audit Policy',
        description:
          'This is an AWS managed policy that provides read-only access to discover and provide insights on AWS resources',
      },
      AriksaS3GetObjectPolicy: {
        label: 'AWS S3 GetObject Policy',
        description:
          'This is a custom policy used to read user and network logs stored in your S3 buckets',
      },
      AriksaReadAccessPolicy: {
        label: 'AWS Read Access Policy',
        description:
          'This is a custom policy that obtains read-only permissions that are not provided by Security Audit Policy required to discover and provide insights on AWS resources',
      },
    };

    return (
      <AccordionItem border="none" key={permission.name + '-permission'}>
        {({ isExpanded }) => (
          <>
            <AccordionButton {...permissionStyles.button} py={3}>
              <Stack textAlign="left">
                <HStack>
                  {collapseExpandIcon(isExpanded)}
                  <Box {...permissionStyles.label}>
                    {permissionsMapping?.[permission?.name]?.label}
                  </Box>
                </HStack>
                <Box pl={8}>
                  {permissionsMapping?.[permission?.name]?.description}
                </Box>
              </Stack>
            </AccordionButton>
            <AccordionPanel pb={2} pl={8}>
              <Stack spacing={4}>
                {map(permission.permissions, permission => (
                  <PermissionComponent permission={permission} />
                ))}
              </Stack>
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    );
  };

  return (
    <Stack h="full">
      <Box>
        For the IAM Role used by Ariksa, the following minimum permissions are
        required
      </Box>
      {isLoading && <CustomSpinner loading={isLoading} />}
      {!isLoading && (
        <Accordion allowMultiple>{map(data, o => permissionItem(o))}</Accordion>
      )}
    </Stack>
  );
};
